  /*
    Email popup — captures email to Shopify's newsletter form
    (works without Klaviyo). On success, shows the discount code.
    Trigger: 15 seconds OR exit-intent (whichever first). Shown once per visitor.
  */
  (function() {
    var KEY = 'pp_popup_shown_v1';
    var SUBMITTED_KEY = 'pp_popup_submitted_v1';
    var GIFT_DISMISSED_KEY = 'pp_popup_gift_dismissed_v1';
    var VISITED_KEY = 'pp_visited_v1';
    var pop = document.getElementById('pp-email-popup');
    var giftWrap = document.getElementById('pp-gift-wrap');
    var giftBtn = document.getElementById('pp-gift-reopener');
    var giftDismiss = document.getElementById('pp-gift-dismiss');
    if (!pop) return;

    /* DESIGN MODE — when true, popup opens immediately on every page load
       and bypasses every "shown / submitted / dismissed / visited" gate.
       Production: false. Override at runtime with `?ppshow=1` for design
       iteration; that also clears all flags so the popup shows fresh.

       Back to the real gate: forcing this true made every page load reopen
       the full popup, which buried the persistent reopener icon before it
       could ever be seen — the two behaviors can't coexist. Test the real
       flow at http://127.0.0.1:9292/?ppshow=1 (forces + resets fresh), then
       browse to another page with a plain URL to see the gift icon persist. */
    var DESIGN_MODE = location.search.indexOf('ppshow=1') !== -1;
    var DEBUG = location.search.indexOf('ppdebug=1') !== -1;
    function log() { if (DEBUG) try { console.log.apply(console, ['[pp-popup]'].concat([].slice.call(arguments))); } catch (e) {} }
    var submitted = false;
    log('init — DESIGN_MODE=' + DESIGN_MODE);

    function getFlag(k) { try { return !!localStorage.getItem(k); } catch (e) { return false; } }
    function setFlag(k) { try { localStorage.setItem(k, '1'); } catch (e) {} }

    /* ?ppshow=1 / ?ppreset=1 — wipe every flag so the popup behaves like a
       brand-new visit. Must run BEFORE the first-time-visitor capture below. */
    if (location.search.indexOf('ppreset=1') !== -1 || location.search.indexOf('ppshow=1') !== -1) {
      try {
        localStorage.removeItem(KEY);
        localStorage.removeItem(SUBMITTED_KEY);
        localStorage.removeItem(GIFT_DISMISSED_KEY);
        localStorage.removeItem(VISITED_KEY);
      } catch (e) {}
    }

    /* Once-per-browser gate: the popup is shown one time per browser via the
       existing alreadyShown() / markShown() pair (pp_popup_shown_v1 key). A
       previous "first-time-visitor" gate that set a flag on every page load
       was killing the popup on the second pageview within the same session,
       so it never fired. Removed. */
    log('hasSubmitted=' + getFlag(SUBMITTED_KEY) + ' alreadyShown=' + getFlag(KEY));

    function hasSubmitted()    { return getFlag(SUBMITTED_KEY); }
    function giftIsDismissed() { return getFlag(GIFT_DISMISSED_KEY); }
    function alreadyShown() {
      if (DESIGN_MODE) return false;
      return getFlag(KEY);
    }
    function markShown() {
      if (DESIGN_MODE) return;
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    function markSubmitted()      { submitted = true; setFlag(SUBMITTED_KEY); }
    function dismissGiftForever() { setFlag(GIFT_DISMISSED_KEY); hideGift(); }

    function showGift() {
      if (!giftWrap) return;
      if (submitted || hasSubmitted() || giftIsDismissed()) return;
      giftWrap.classList.add('is-visible');
    }
    function hideGift() {
      if (giftWrap) giftWrap.classList.remove('is-visible');
    }
    /* Lock/unlock background scroll. Captures the current scrollY before
       making <body> position:fixed (which would otherwise jump to the top),
       then restores it on unlock. Works on iOS Safari where overflow:hidden
       alone doesn't prevent touch scroll. */
    var lockedScrollY = 0;
    function lockScroll() {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.style.setProperty('--pp-scroll-y', '-' + lockedScrollY + 'px');
      document.documentElement.classList.add('pp-pop-locked');
      document.body.classList.add('pp-pop-locked');
    }
    function unlockScroll() {
      document.documentElement.classList.remove('pp-pop-locked');
      document.body.classList.remove('pp-pop-locked');
      document.documentElement.style.removeProperty('--pp-scroll-y');
      window.scrollTo(0, lockedScrollY);
    }

    /* Shrinks the pretitle/title one-row text just enough that it never
       wraps, at any viewport width - clamp() alone can't guarantee that for
       an arbitrary string, this measures and backs off until it fits. */
    function fitOneRow(el) {
      if (!el) return;
      el.style.fontSize = '';
      var parent = el.parentElement;
      var min = 20;
      var size = parseFloat(getComputedStyle(el).fontSize);
      while (el.scrollWidth > parent.clientWidth + 0.5 && size > min) {
        size -= 1;
        el.style.fontSize = size + 'px';
      }
    }
    function fitPopText() {
      fitOneRow(pop.querySelector('.pp-pop__pretitle'));
      fitOneRow(pop.querySelector('.pp-pop__title'));
    }
    var resizeT;
    window.addEventListener('resize', function() {
      clearTimeout(resizeT);
      resizeT = setTimeout(function() {
        if (pop.classList.contains('is-open')) fitPopText();
      }, 100);
    });

    function open() {
      if (alreadyShown()) return;
      pop.classList.add('is-open');
      lockScroll();
      hideGift();
      markShown();
      requestAnimationFrame(fitPopText);
    }
    function close() {
      pop.classList.remove('is-open');
      unlockScroll();
      if (!submitted && !hasSubmitted() && !giftIsDismissed()) showGift();
    }

    /* If a previous visit submitted or dismissed, never show the gift again.
       Otherwise, if they've already seen the popup once (so it won't pop up
       again per the once-per-browser gate below), leave the small reopener
       showing on every page for the rest of this visit - and future visits,
       until they claim it or explicitly dismiss it. A closed popup is a soft
       "not now", not a hard "never"; without this the icon only lived on the
       single page they closed it on and vanished the moment they navigated. */
    if (hasSubmitted() || giftIsDismissed()) hideGift();
    else if (alreadyShown()) showGift();

    /* Reopen on gift click */
    if (giftBtn) giftBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      pop.classList.add('is-open');
      lockScroll();
      hideGift();
      requestAnimationFrame(fitPopText);
    });

    /* Permanent dismiss on × click — stop propagation so the underlying gift
       button doesn't ALSO fire (which would reopen the popup). */
    if (giftDismiss) giftDismiss.addEventListener('click', function(e) {
      e.stopPropagation();
      dismissGiftForever();
    });

    /* Design helpers — run these in DevTools console to test from scratch:
         window.ppResetPopup()   → clears all localStorage flags + reopens popup
         window.ppShowGift()     → manually shows the gift icon
       Also: append `?ppreset=1` to ANY URL to clear flags on page load. */
    window.ppResetPopup = function() {
      try {
        localStorage.removeItem(KEY);
        localStorage.removeItem(SUBMITTED_KEY);
        localStorage.removeItem(GIFT_DISMISSED_KEY);
        localStorage.removeItem(VISITED_KEY);
      } catch (e) {}
      submitted = false;
      pop.classList.remove('is-success');
      hideGift();
      pop.classList.add('is-open');
      lockScroll();
      requestAnimationFrame(fitPopText);
      console.log('[pp-popup] reset — visitor + popup flags cleared. Reload to be treated as a brand-new visitor.');
    };
    window.ppShowGift = function() { showGift(); };

    /* Close handlers */
    pop.querySelector('[data-pp-pop-close]').addEventListener('click', close);
    pop.addEventListener('click', function(e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close();
    });

    /* Form submit — POSTs to Shopify newsletter endpoint */
    var form = pop.querySelector('[data-pp-pop-form]');
    var emailInput = pop.querySelector('[data-pp-pop-email]');
    var submitBtn = pop.querySelector('[data-pp-pop-submit]');

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = (emailInput.value || '').trim();
      if (!email || email.indexOf('@') < 0) {
        emailInput.focus();
        return;
      }
      submitBtn.disabled = true;
      submitBtn.textContent = ((window.ppPopupI18n && window.ppPopupI18n.sending) || 'Sending...');

      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[tags]', 'newsletter,popup-mysterygift');
      fd.append('contact[email]', email);

      fetch('/contact#contact_form', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .catch(function(){})
        .finally(function() {
          pop.classList.add('is-success');
          submitBtn.disabled = false;
          markSubmitted();
          hideGift();
        });
    });

    /* ============================================================
       Trigger logic — best-practice multi-signal exit intent
       ------------------------------------------------------------
       The popup fires on the FIRST of these signals after page load:
         1. 15 second timer (catches engaged readers who haven't bounced yet)
         2. DESKTOP exit intent: mouse leaves the top of the viewport
            (cursor heading toward URL bar / back button / browser close)
         3. MOBILE exit intent: rapid scroll-up after the user had scrolled
            down — they're heading back to the top, often to switch tabs or
            close the page. Also fires when ~80% scroll depth is reached
            (engaged reader about to bottom-out → catch them before they leave).
         4. Tab visibility lost then regained: shows when the user comes back
            to the tab (they were doing something else, now refocused).

       Suppression rules:
         - Never fires inside the first 4 seconds (avoids interrupting initial
           page paint / micro-attention before user has oriented).
         - Never fires twice (`triggered` flag).
         - Never fires if user already submitted or popup was dismissed via
           localStorage.
       ============================================================ */
    var triggered = false;
    var pendingTrigger = false;

    /* Suppress the popup whenever the customer is mid-flow on something that
       leads straight to a purchase - interrupting either tanks both UX AND
       conversion. The image uploader sets `ppu-modal-open` on the <body>
       while it's open; the cart drawer marks itself `.active`. */
    function inImageEditor() {
      return document.body.classList.contains('ppu-modal-open');
    }
    function cartDrawerOpen() {
      var cd = document.querySelector('cart-drawer');
      return !!(cd && cd.classList.contains('active'));
    }
    function midPurchaseFlow() {
      return inImageEditor() || cartDrawerOpen();
    }

    function trigger() {
      log('trigger() called', { triggered: triggered, DESIGN_MODE: DESIGN_MODE, inEditor: inImageEditor() });
      if (triggered) { log('skip: already triggered'); return; }
      if (midPurchaseFlow()) { log('defer: mid purchase flow'); pendingTrigger = true; return; }
      triggered = true;
      log('opening popup');
      open();
    }

    /* Watch <body> for the ppu-modal-open class going away — that means the
       customer just closed the image editor (closing the cart drawer doesn't
       touch this class, so it doesn't spuriously wake this observer).

       The editor session alone easily eats the 15s engagement timer, so the
       moment it closes there's almost always a trigger sitting pending - and
       that's exactly the instant the customer is reaching for "Add to cart".
       Firing 600ms later was functionally the same interruption the
       suppression was meant to prevent, just not literally simultaneous.
       A real grace period lets them actually complete that click (or open
       the cart drawer, which extends the suppression further) before any
       pending trigger is allowed to fire. */
    var GRACE_MS = 8000;
    if ('MutationObserver' in window) {
      var bodyObserver = new MutationObserver(function() {
        if (pendingTrigger && !inImageEditor() && !triggered) {
          pendingTrigger = false;
          setTimeout(function () {
            if (!triggered && !midPurchaseFlow()) trigger();
          }, GRACE_MS);
        }
      });
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    if (DESIGN_MODE) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', trigger);
      } else {
        trigger();
      }
    } else {
      /* Don't even start watching for triggers until the user has been on the
         page ≥4s — prevents accidental fires while page is still loading. */
      setTimeout(function() {
        if (triggered) return;

        /* 1) Engagement timer — fires at 15s if nothing else has fired */
        var timerHandle = setTimeout(trigger, 11000); // 4s + 11s = 15s total

        /* 2) Desktop exit intent — mouse leaves through the top */
        function onDesktopExit(e) {
          if (e.clientY < 5 && e.relatedTarget == null) trigger();
        }
        document.addEventListener('mouseleave', onDesktopExit);
        /* Some browsers don't fire mouseleave reliably — also watch mouseout */
        document.addEventListener('mouseout', function(e) {
          if (e.clientY < 5 && (e.relatedTarget == null || e.relatedTarget.nodeName === 'HTML')) trigger();
        });

        /* 3) Mobile exit intent — fast scroll-up after scrolling down,
           OR ≥80% scroll depth reached. */
        var lastY = window.scrollY;
        var lastT = Date.now();
        var maxDepth = 0;
        var sawDownscroll = false;
        function onScroll() {
          var y = window.scrollY;
          var t = Date.now();
          var doc = document.documentElement;
          var depth = (y + window.innerHeight) / Math.max(doc.scrollHeight, 1);
          if (depth > maxDepth) maxDepth = depth;

          /* Catch the long-read user near the bottom (~80%) — they're about
             to bottom-out + leave. Fire BEFORE they actually finish. */
          if (depth > 0.8 && maxDepth > 0.8) trigger();

          /* Detect "I was scrolling down, now I'm scrolling rapidly UP" — a
             strong mobile exit signal (user heading back to URL bar / tabs). */
          if (y > lastY) sawDownscroll = true;
          if (sawDownscroll && lastY - y > 80 && (t - lastT) < 250 && y < 300) {
            trigger();
          }
          lastY = y;
          lastT = t;
        }
        window.addEventListener('scroll', onScroll, { passive: true });

        /* 4) Tab visibility regained — user came back to the tab */
        var hiddenAt = 0;
        document.addEventListener('visibilitychange', function() {
          if (document.hidden) {
            hiddenAt = Date.now();
          } else if (hiddenAt && Date.now() - hiddenAt > 1500) {
            trigger();
          }
        });

        /* Once any signal fires, the listeners stop mattering — `triggered`
           gate prevents re-entry. But cancel the timer to be clean. */
        var origTrigger = trigger;
        trigger = function() {
          clearTimeout(timerHandle);
          origTrigger();
        };
      }, 4000);
    }

    /* Manual open hook for testing or footer link */
    window.ppOpenEmailPopup = function() {
      try { localStorage.removeItem(KEY); } catch (e) {}
      open();
    };
  })();
